
import { MealCategory } from "@/components/meals/MealCategory";

interface MealCategoriesProps {
  meals: any[];
  isLoading: boolean;
}

export const MealCategories = ({ meals, isLoading }: MealCategoriesProps) => {
  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">Loading...</div>
    );
  }

  if (!meals || meals.length === 0) {
    return (
      <div className="container mx-auto px-4 py-8 text-center">
        <p className="text-lg text-gray-600">No meals found matching your criteria.</p>
        <p className="text-sm text-gray-500 mt-2">Try adjusting your filters or search terms.</p>
      </div>
    );
  }

  console.log('Meal types in data:', meals.map(meal => meal.meal_type));

  // Filter meals that have a numerical distance within 10 miles
  const nearbyMeals = meals.filter(meal => {
    if (typeof meal.distance === 'string' && meal.distance.includes('mi')) {
      const distance = parseFloat(meal.distance);
      return !isNaN(distance) && distance <= 10;
    }
    return false;
  });

  const popularMeals = meals.filter(meal => Number(meal.rating) >= 4.5);
  // Reverse new arrivals to show newest first
  const newArrivals = [...meals].reverse();
  const featuredMeals = meals.filter(meal => meal.is_featured);
  
  // Add logging for meal type filters
  const breakfastMeals = meals.filter(meal => {
    console.log('Checking breakfast meal:', meal.name, meal.meal_type);
    return meal.meal_type === 'breakfast';
  });
  
  const lunchMeals = meals.filter(meal => {
    console.log('Checking lunch meal:', meal.name, meal.meal_type);
    return meal.meal_type === 'lunch';
  });
  
  const dinnerMeals = meals.filter(meal => {
    console.log('Checking dinner meal:', meal.name, meal.meal_type);
    return meal.meal_type === 'dinner';
  });
  
  const dessertMeals = meals.filter(meal => {
    console.log('Checking dessert meal:', meal.name, meal.meal_type);
    return meal.meal_type === 'dessert';
  });
  
  const bakedGoodsMeals = meals.filter(meal => {
    console.log('Checking baked goods meal:', meal.name, meal.meal_type);
    return meal.meal_type === 'baked_goods';
  });
  
  const breadMeals = meals.filter(meal => {
    console.log('Checking bread meal:', meal.name, meal.meal_type);
    return meal.meal_type === 'bread';
  });

  console.log('Category counts:', {
    nearby: nearbyMeals.length,
    popular: popularMeals.length,
    newArrivals: newArrivals.length,
    featured: featuredMeals.length,
    breakfast: breakfastMeals.length,
    lunch: lunchMeals.length,
    dinner: dinnerMeals.length,
    dessert: dessertMeals.length,
    bakedGoods: bakedGoodsMeals.length,
    bread: breadMeals.length
  });

  return (
    <div className="space-y-1 md:space-y-2">
      {newArrivals.length > 0 && <MealCategory title="New Arrivals" meals={newArrivals} />}
      {popularMeals.length > 0 && <MealCategory title="Most Popular" meals={popularMeals} />}
      {nearbyMeals.length > 0 && <MealCategory title="Near You" meals={nearbyMeals} />}
      {featuredMeals.length > 0 && <MealCategory title="Featured Meals" meals={featuredMeals} />}
      {breakfastMeals.length > 0 && <MealCategory title="Breakfast" meals={breakfastMeals} />}
      {lunchMeals.length > 0 && <MealCategory title="Lunch" meals={lunchMeals} />}
      {dinnerMeals.length > 0 && <MealCategory title="Dinner" meals={dinnerMeals} />}
      {dessertMeals.length > 0 && <MealCategory title="Dessert" meals={dessertMeals} />}
      {bakedGoodsMeals.length > 0 && <MealCategory title="Baked Goods" meals={bakedGoodsMeals} />}
      {breadMeals.length > 0 && <MealCategory title="Bread" meals={breadMeals} />}
    </div>
  );
};
